import React from 'react';
import {Navigation} from '../Navigation';
import * as RouterActions from '../../actions/RouterActions'
import {useDispatch} from 'react-redux';

export const RmgNavigation = function(props){
    const dispatch = useDispatch();

    return (
        <Navigation title="RMG" icon="bolt" breadcrumb={props.breadcrumb} menu={
            [
                {
                    caption: 'Browser',
                    icon: 'folder',
                    active: props.active === 'browser',
                    onClick: () => dispatch(RouterActions.push('/rmg/browser/'))
                },
                {
                    caption: 'Märkte',
                    icon: 'folder',
                    active: props.active === 'markets',
                    onClick: () => dispatch(RouterActions.push('/rmg/markets/'))
                }
                /*{
                    caption: 'Bereitstellen',
                    icon: 'share',
                    active: props.active === 'publish',
                    entries: [
                        {
                            caption: 'Mobile App',
                            icon: 'tablet',
                            onClick: () => dispatch(RouterActions.push('/staticfiles/publish/app')),
                            href: '/staticfiles/publish/app'
                        },
                        {
                            caption: 'OTT',
                            icon: 'tablet',
                            onClick: () => dispatch(RouterActions.push('/staticfiles/publish/kiosk')),
                            href: '/staticfiles/publish/kiosk'
                        }
                    ]
                }*/
            ]
        }>
            {props.children}
        </Navigation>
    )
}